<template>
  <ValidationProvider
    :name="validationLabel || label"
    :rules="rules"
    :vid="validationPath"
    :custom-messages="customMessages"
    slim
    v-slot="{ reset, errors, dirty }"
    v-bind="$attrs"
  >
    <b-form-group
      :label="label"
      :invalid-feedback="compoundFeedback(errors)"
      :state="compoundState(errors)"
      v-bind="$attrs"
    >
      <slot
        :clear-errors="clearErrorsHandler(reset)"
        :state="compoundState(errors)"
        :errors="errors"
        :dirty="dirty"
      />
    </b-form-group>
  </ValidationProvider>
</template>

<script>
import ValidatingInput from './mixins/ValidatingInput';

export default {
  mixins: [ValidatingInput],
  props: {
    label: String,
    validationLabel: String,
    rules: [String, Object],
    customMessages: Object,
  },
  methods: {
    clearErrorsHandler(reset) {
      return (soft = false) => (soft ? reset() : this.defaultClearValidation());
    },
  },
};
</script>
